import { render, staticRenderFns } from "./PositionList.vue?vue&type=template&id=178da6ca&scoped=true&"
import script from "./PositionList.vue?vue&type=script&lang=js&"
export * from "./PositionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178da6ca",
  null
  
)

export default component.exports